import {
	styled,
} from '@mui/material'

import {
	HStack,
} from '@/shared/components/stack'
import type {
	StackProps,
} from '@/shared/components/stack/stack/stack.types'

export const HStackPageHeader = styled(HStack)<StackProps>`
	width: 100%;
	background-color: var(--surface-container-color);
	border-bottom:   var(--outline-base);
	padding: var(--base-spacing-1) var(--base-spacing-1);
	padding-top: calc(var(--tg-content-safe-area-inset-top, 0px) + var(--base-spacing-1));
	position: relative;
`
